import { useTranslation as useReactI18nextTranslation } from "react-i18next";
import { isRTL, type SupportedLanguage } from "./config";

export const useTranslation = () => {
  const { t, i18n } = useReactI18nextTranslation("translations");
  const language = i18n.language as SupportedLanguage;
  const rtl = isRTL(language);

  return {
    t,
    language,
    rtl,
  };
};
